import "./CardBody.css";

function CardBody(props: {
  heading?: string;
  paragraph?: string;
  button?: string;
}) {
  return (
    <div className="card-body df fdc aic jcsb">
      <h1 className="card-body-heading">{props.heading}</h1>
      <p className="card-body-paragraph">{props.paragraph}</p>
    </div>
  );
}

export default CardBody;
